export const PenDimensionPipeSegmentStatus = {
  NotStarted: 1,
  Ongoing: 2,
  Done: 3,
  Approved: 4,
  NotApproved: 5,
} as const;
